module.exports = require('./helpers/bundle-url').getBundleURL('EVgbq') + "optimism.0579c3e6.svg";